
import { VNode } from 'vue';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { EVENTS } from '../bus/events.const';
import { DynamicConfig, EmpathyXConfig } from '../models';
import { SUBMODULES_PATHS } from '../store';
import { CONFIG_GETTERS_KEYS } from '../store/config/config.const';
import { CoreClassesMixin } from './mixins/core/core-classes.mixin';
import { CoreWiringMixin } from './mixins/core/core-wiring.mixin';
import { DynamicTemplateMixin } from './mixins/dynamic-render.mixin';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.core, ['coreStyles', 'stateLoadedFromCache']),
    ...mapState(SUBMODULES_PATHS.config, ['dynamic']),
    ...mapGetters(SUBMODULES_PATHS.config, {
      config: CONFIG_GETTERS_KEYS.config
    })
  }
})
export default class Core extends Mixins(CoreClassesMixin, CoreWiringMixin, DynamicTemplateMixin) {
  config: EmpathyXConfig;
  coreStyles: Partial<CSSStyleDeclaration>;
  dynamic: DynamicConfig;
  stateLoadedFromCache: boolean;

  @Watch('config', { immediate: true })
  onConfigChange(config: EmpathyXConfig) {
    this.$x.emit(EVENTS.ConfigChanged, config);
  }

  created() {
    if (this.stateLoadedFromCache) {
      this.$x.emit(EVENTS.StateLoadedFromCache);
    } else {
      this.$x.emit(EVENTS.EmpathyXCreated);
    }
  }

  mounted() {
    if (this.open) {
      this.openFinished();
    }
  }

  render() {
    return this.createTransitionNode();
  }

  openFinished() {
    this.$x.emit(EVENTS.OpenFinished);
  }

  createTransitionNode() {
    return this.$createElement('transition', {
      attrs: {
        name: 'ebx-empathy-x--open'
      }, on: {
        afterEnter: this.openFinished
      }
    }, [this.createTemplateNode()]);
  }

  createTemplateNode(): VNode {
    const templateTag = this.config.core.template;
    return this.$createElement(templateTag, {
      class: this.coreClasses,
      attrs: {
        id: 'empathy-x',
        dir: this.dynamic.documentDirection
      },
      style: this.coreStyles,
      directives: [
        {
          name: 'show',
          value: this.open
        }
      ]
    }, this.renderComponents(this.config.core.components));
  }
}
